import { Button, ButtonVariant } from "@merge-api/merge-javascript-shared";
import { ExternalLink } from "lucide-react";
import { CommonModelDiffRunExecution, ViewExecutionLogsHandler } from "../entities";

interface SubRunLogLinksProps {
  diffRun: CommonModelDiffRunExecution;
  onViewExecutionLogs?: ViewExecutionLogsHandler;
}

/**
 * "View logs" buttons for a diff's published/staged blueprint sub-runs. Each opens that run's
 * step-I/O logs in the console viewer via onViewExecutionLogs. Renders nothing when no handler is
 * wired (e.g. the staged-versions tab, which has no console viewer) or when no sub-run exists yet.
 */
const SubRunLogLinks = ({ diffRun, onViewExecutionLogs }: SubRunLogLinksProps) => {
  if (!onViewExecutionLogs) {
    return null;
  }

  const links = [
    { label: "View published run logs", id: diffRun.published_run?.async_task_execution_id },
    { label: "View staged run logs", id: diffRun.staged_run?.async_task_execution_id },
  ].filter((link): link is { label: string; id: string } => Boolean(link.id));

  if (links.length === 0) {
    return null;
  }

  return (
    <div className="mt-2 flex flex-row flex-wrap gap-2">
      {links.map((link) => (
        <Button
          key={link.id}
          size="sm"
          variant={ButtonVariant.TextBlack}
          leftIcon={<ExternalLink size={14} />}
          onClick={(e) => {
            // stop the click from bubbling to the surrounding card (which opens the diff drawer)
            e.stopPropagation();
            onViewExecutionLogs(link.id);
          }}
        >
          {link.label}
        </Button>
      ))}
    </div>
  );
};

export default SubRunLogLinks;
